import { render, staticRenderFns } from "./CallIssuesActiveDeactivate.vue?vue&type=template&id=df9f09ea"
import script from "./CallIssuesActiveDeactivate.vue?vue&type=script&lang=js"
export * from "./CallIssuesActiveDeactivate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports